// extracted by mini-css-extract-plugin
module.exports = {"link":"CategoryLinkControl_link__767LK"};